export const ENDPOINTS = {
  get_submission_details: "teaming/team/",
  get_submission_status: "teaming/submission-status/",
  put_submission: "teaming/update-team/",
};